export type MaybeObject<ObjectToUpdate extends Record<string, unknown>> = {
  [Key in keyof ObjectToUpdate]: ObjectToUpdate[Key] | null | undefined;
};

export type ParsedBooleanValue = 'true' | 'false';

export type ValueOf<T> = T[keyof T];

export type ParsedCardTypeValue = 'PHYSICAL' | 'VIRTUAL';

export interface IOption {
  id: string;
  label: string;
  value: string;
  data?: string | number;
}

export interface IPaginationRequest {
  page: number;
  limit: number;
}

export interface ISortingRequest {
  sortBy?: string;
  orderBy?: 'asc' | 'desc' | null;
}

export interface IPaginationResponse<T> {
  data: T[];
  total: number;
}

export enum LayoutAreas {
  ONBOARDING = 'onboarding',
}
